export const COMMENT_ITEM_CONSTS = {
  block: 'Заблокировать',
  forСonsideration: 'На рассмотрение',
  postIt: 'Запостить',
  postItAbove: 'Запостить это и выше'
}
